// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordPolicies.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import action from 'modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import EventsUtils from 'share/utils/Izenda.EventUtils';

const notifyChange = EventsUtils.notifyChange;

const Header = connect()(function (props: any) {
  const {localization} = props;
  return (
    <div onClick={props.collapseToggle}>
      <i className='icon-toggle-triangle'/>
      <label className='panel-title'>
        {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_USER_POLICIES')}
      </label>
    </div>
  );
});

/**
 * Hide user id from non-admin users.
 */
const UserPolicyHideUserProfile = connect(action)(function (props: any) {
  const {localization, store: {model}} = props;
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='8'>
        <Input
          type='checkbox'
          className='u_marginLeft'
          checked={model.hideUserProfile}
          onChange={notifyChange(model.updateValueByKey.bind(model, 'hideUserProfile'), EventsUtils.CHECKBOX)}
        />
        <label>
          {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_USER_HIDE_PROFILE')}
        </label>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

/**
 * Hide user id from non-admin users.
 */
const UserPolicyHideUserId = connect(action)(function (props: any) {
  const {localization, store: {model}} = props;
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='8'>
        <Input
          type='checkbox'
          className='u_marginLeft'
          checked={model.hideUserId}
          onChange={notifyChange(model.updateValueByKey.bind(model, 'hideUserId'), EventsUtils.CHECKBOX)}
        />
        <label>
          {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_USER_HIDE_ID')}
        </label>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

/**
 * User policies component
 */
const UserPolicies = connect(action)(function (props: any) {
  const header = {
    component: Header
  };
  return (
    <Panel className='u_fullHeight u_noMarginAll u_marginTop' header={header} collapsible expanedOption>
      <GridLayout>
        <UserPolicyHideUserProfile {...props}/>
        <UserPolicyHideUserId {...props}/>
      </GridLayout>
    </Panel>
  );
});
export default UserPolicies;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/UserPolicies/Izenda.UserPolicies.js